<div class="lgpd-container">
    <!-- Loader -->
    <div class="modern-loader" *ngIf="carregando">
        <div class="loader-rings">
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
        </div>
        <div class="loader-title">CARREGANDO TERMOS</div>
    </div>

    <!-- Card Principal -->
    <div class="lgpd-card" *ngIf="!carregando">
        <!-- Ícone de escudo animado -->
        <div class="shield-icon">
            <i class="pi pi-shield"></i>
        </div>

        <div class="lgpd-title">Termos de Uso e Privacidade</div>
        <div class="lgpd-subtitle">
            Versão {{termoVersao}} &middot; Lei Geral de Proteção de Dados
        </div>

        <!-- Área de texto dos termos com scroll -->
        <div class="termos-scroll-area" id="termos-scroll-area">
            <div class="termos-conteudo" [innerHTML]="termoTexto"></div>
        </div>

        <!-- Checkbox de aceite -->
        <label class="aceite-checkbox-wrapper" (click)="aceitou = !aceitou">
            <div class="custom-checkbox" [class.checked]="aceitou">
                <i class="pi pi-check" *ngIf="aceitou"></i>
            </div>
            <span class="aceite-label">
                Li e concordo com os termos apresentados
            </span>
        </label>

        <!-- Botão prosseguir -->
        <button class="lgpd-btn" [class.disabled]="!aceitou || processando" (click)="confirmarAceite()">
            <span *ngIf="!processando">Prosseguir <i class="pi pi-arrow-right" style="margin-left: 8px;"></i></span>
            <span *ngIf="processando">Registrando aceite... <i class="pi pi-spin pi-spinner" style="margin-left: 8px;"></i></span>
        </button>

        <div class="lgpd-footer">
            <i class="pi pi-lock" style="margin-right: 6px;"></i>
            Seus dados estão protegidos conforme a LGPD <a href="https://www.gov.br/esporte/pt-br/acesso-a-informacao/lgpd" target="_blank">(Lei 13.709/2018)</a>
        </div>
    </div>
</div>
